import BaseDto from './BaseDto';

export default class CalculetteDto extends BaseDto {
  /**
   *
   * @returns {any}
   */
  get schema() { // eslint-disable-line
    return Object.assign(super.schema,
      {
        periodeFiscale: undefined,
        bareme: undefined,
        codeBaremePrelevement: undefined,
        revenuContribuable: undefined,
        revenuContribuableCHF: undefined,
        revenuContribuableEUR: undefined,
        revenuConjoint: undefined,
        revenuConjointCHF: undefined,
        revenuConjointEUR: undefined,
        isTaux: undefined,
        revenuImpose: undefined,
        taux: undefined,
        montantImpot: undefined,
        revenuUtilisePourLeTaux: undefined, // Revenu utilisé pour déterminer le taux
        tauxContribuable: undefined, // Taux prélèvement Contribuable
        montantImpotContribuable: undefined, // Montant prélèvement Contribuable
        tauxConjoint: undefined, // Taux prélèvement Conjoint
        montantImpotConjoint: undefined, // Montant prélèvement Conjoint
        montantImpotCouple: undefined, // Total prélèvement Couple
        solde: undefined, // Remboursement par AFC si > 0 sinon Somme restant due par contribuable
        isBaremeRectif: undefined,
        isBaremeAjuste: undefined,
        isBaremeAjusteALaHausse: undefined,
        tauxALaBaisse: undefined, // Taux de prélevement Cb pour ce barème ajusté à la baisse
        tauxALaHausse: undefined, // Taux de prélevement Cb pour le barème normal à la hausse
        tauxChange: undefined,
      });
  }

  /**
   * Fonction appelée en callback pour créer une nouvelle instance
   * @param inoJson Flux json
   * @return {CalculetteDto}
   */
  static getFactory(inoJson = {}) {
    return new CalculetteDto(inoJson);
  }
}
